// extracted by mini-css-extract-plugin
export var content = "PrivacyPolicy-module__content___L04eY";
export var body = "PrivacyPolicy-module__body___D08YY";
export var header = "PrivacyPolicy-module__header___eYQc3";
export var dash = "PrivacyPolicy-module__dash___HOtBy";
export var disc = "PrivacyPolicy-module__disc___EY9vO";